export default __webpack_public_path__ + "../staticImages/winetasting-placeholder.jpg";